import React from 'react'
import ProjectTemplate from '../../Projects/ProjectTemplate/ProjectTemplate'
import CheetSheetTemplate from '../CheetSheet/CheetSheetTemplate'
import JavaScript1 from '../../../media/JavaScript-1.png'
import JavaScript2 from '../../../media/JavaScript-2.png'
import JavaScript3 from '../../../media/JavaScript-3.png'
import JavaScript4 from '../../../media/JavaScript-4.png'
export default function JavaScript(props) {
    const html = '<script type="text/javascript"> //JS code goes here </script>'

    return (
        <>
            <ProjectTemplate name='JavaScript CheetSheet' mode={props.mode} isValue={props.isValue} >
                <div className="aboutMe blogDiv">
                    <CheetSheetTemplate
                        language='javascript'
                        headerStyle='none'
                        des={`JavaScript is a popular programming language that is widely used to create interactive elements on websites. It is a client-side scripting language, which means that it is executed by the user's web browser rather than on the server. This makes it an essential tool for web development and allows developers to create dynamic and interactive websites and web applications.`}
                        headStyle='none' 
                        img={JavaScript1}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        headerStyle='none'
                        des={`JavaScript is an object-oriented language, which means that it is based on the concept of objects and their properties and methods. It is also a high-level programming language, which means that it is relatively easy to read and understand, even for those who are new to programming.`}
                        headStyle='none' />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        headerStyle='none'
                        des={`One of the primary uses of JavaScript is to manipulate the Document Object Model (DOM) of a webpage. The DOM is a tree-like structure that represents the structure and content of a webpage. JavaScript allows developers to access and manipulate the DOM, which enables them to add, delete, or modify elements on a webpage in real-time.`}
                        headStyle='none' />
                    <CheetSheetTemplate
                        language='javascript'
                        headerStyle='none'
                        des={`JavaScript is also used for validation of form input, which is a common feature on websites. It allows developers to create custom form validation rules and display error messages to the user if the form is not filled out correctly.`}
                        headStyle='none'
                        img={JavaScript2}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        headerStyle='none'
                        des={`In addition to these core features, JavaScript is also used for a wide range of other tasks such as creating animations, interacting with APIs, and handling events.`}
                        headStyle='none' />
                    <CheetSheetTemplate
                        language='javascript'
                        headerStyle='none'
                        des={`Overall, JavaScript is a powerful and versatile programming language that is essential for building modern websites and web applications. It is easy to learn and has a vast community of developers and resources available, making it a great choice for anyone interested in pursuing a career in web development.`}
                        headStyle='none'
                        img={JavaScript3}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        headerStyle='none'
                        des={`JavaScript is a popular programming language that is widely used to create interactive elements on websites. It is a client-side scripting language, which means that it is executed by the user's web browser rather than on the server. This makes it an essential tool for web development and allows developers to create dynamic and interactive websites and web applications.`}
                        headStyle='none' />
                    <CheetSheetTemplate
                        language='javascript'
                        headerStyle='none'
                        des={`One of the primary uses of JavaScript is to manipulate the Document Object Model (DOM) of a webpage. The DOM is a tree-like structure that represents the structure and content of a webpage. JavaScript allows developers to access and manipulate the DOM, which enables them to add, delete, or modify elements on a webpage in real-time.`}
                        headStyle='none'
                        img={JavaScript4}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        headerStyle='none'
                        des={`For example, let's say we have a simple HTML page with a button and a paragraph element. We can use JavaScript to change the text of the paragraph element when the button is clicked.`}
                        headStyle='none' />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        des={`Here is the HTML code:`} code={`<button id="myButton">Click me!</button>\n<p id="myParagraph">This is some text.</p>`}
                        headStyle='none' />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        headerStyle='none' heading="JavaScript Basics" des='Set of JavaScript basic synatx to add, execute and write basic programming paradigms in JavaScript'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading="On Page Script" des='Adding internal JavaScript to HTML' code={html} />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading="On Page Script" des='Adding internal JavaScript to HTML' code={`<script src="filename.js"></script>`} />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading="Functions" des='JavaScript Function syntax' code={`function nameOfFunction() {\n\t// function body\n}`} />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading="DOM Element"
                        des='Changing content of a DOM Element'
                        code={`document.getElementById("elementID").innerHTML = "Hello World!";`} />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading="Output"
                        des='This will print the value of a in JavaScript console'
                        code={`console.log(a);`} />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        headerStyle='none'
                        heading="Conditional Statements"
                        des='Conditional statements are used to perform operations based on some conditions.'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading="If Statement"
                        des='The block of code to be executed, when the condition specified is true.'
                        code={`if (condition) {\n\t// block of code to be executed if the condition is true\n}`} />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading="If-else Statement"
                        des='If the condition for the if block is false, then the else block will be executed.'
                        code={`if (condition) {\n\t// block of code to be executed if the condition is true\n} else {\n\t// block of code to be executed if the condition is false\n}`} />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading="Else-if Statement"
                        des='A basic if-else ladder'
                        code={`if (condition1) {\n\t// block of code to be executed if condition1 is true\n} else if (condition2) {\n\t// block of code to be executed if the condition1 is false and\n\t condition2 is true\n} else {\n\t// block of code to be executed if the condition1 is false and condition2 is false\n}`} />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading="Switch Statement"
                        des='Switch case statement in JavaScript'
                        code={`switch (expression) {\n\tcase x:\n\t\t// code block\n\t\tbreak;\n\tcase y:\n\t\t// code block\n\t\tbreak;\n\tdefault:\n\t\t// code block\n}`} />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        headerStyle='none'
                        heading="Iterative Statements (Loops)"
                        des='Iterative statement facilitates programmer to execute any block of code lines repeatedly and can be controlled as per conditions added by the programmer.'

                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading="For Loop"
                        des='For loop syntax in javascript'
                        code={`for (initialization; condition; incrementation;) {\n\t// code block to be executed\n}`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        des='Example:'
                        code={`for (let i = 0; i < 5; i++) {\n\ttext += "Iteration number: " + i + "<br>";\n}`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='While Loop'
                        des='Runs the code till the specified condition is true'
                        code={`while (condition) {\n\t// code block to be executed\n}`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='Do While Loop'
                        des='A do while loop is executed at least once despite the condition being true or false'
                        code={`do {\n\t// run this code in block\n\ti++;\n} while (condition);`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        headerStyle='none'
                        heading="Strings"
                        des='The string is a sequence of characters that is used for storing and managing text data.'

                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='charAt method'
                        des='Returns the character from the specified index.'
                        code={`str.charAt(3)`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='concat method'
                        des='Joins two or more strings together.'
                        code={`str1.concat(str2)`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='index of method'
                        des='Returns the index of the first occurrence of the specified character from the string else -1 if not found.'
                        code={`str.indexOf('substr')`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='match method'
                        des='Searches a string for a match against a regular expression.'
                        code={`str.match(/(chapter \\d+(\\.\\d)*)/i;)`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='replace method'
                        des='Searches a string for a match against a specified string or char and returns a new string by replacing the specified values.'
                        code={`str1.replace(str2)`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='search method'
                        des='Searches a string against a specified value.'
                        code={`str.search('term')`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='split method'
                        des='Splits a string into an array consisting of substrings.'
                        code={`str.split('\\n')`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='substring method'
                        des='Returns a substring of a string containing characters from the specified indices.'
                        code={`str.substring(0,5)`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        headerStyle='none'
                        heading="Arrays"
                        des='The array is a collection of data items of the same type. In simple terms, it is a variable that contains multiple values.'

                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='variable'
                        des='Containers for storing data.'
                        code={`var fruit = ["element1", "element2", "element3"];`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='concat method'
                        des='Joins two or more arrays together.'
                        code={`concat()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='indexOf method'
                        des='Returns the index of the specified item from the array.'
                        code={`indexOf()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='join method'
                        des='Converts the array elements to a string.'
                        code={`join()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='pop method'
                        des='Deletes the last element of the array.'
                        code={`pop()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='reverse method'
                        des='This method reverses the order of the array elements.'
                        code={`reverse()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='sort method'
                        des='Sorts the array elements in a specified manner.'
                        code={`sort()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='toString method'
                        des='Converts the array elements to a string.'
                        code={`toString()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='valueOf method'
                        des='returns the relevant Number Object holding the value of the argument passed'
                        code={`valueOf()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        headerStyle='none'
                        heading="Maths Methods"

                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='ceil method'
                        des='Rounds a number upwards to the nearest integer, and returns the result'
                        code={`ceil(x)`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='exp method'
                        des='Returns the value of E^x.'
                        code={`exp(x)`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='log method'
                        des='Returns the logarithmic value of x.'
                        code={`log(x)`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='pow method'
                        des='Returns the value of x to the power y.'
                        code={`pow(x,y)`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='random method'
                        des='Returns a random number between 0 and 1.'
                        code={`random()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='sqrt method'
                        des='Returns the square root of a number x.'
                        code={`sqrt(x)`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        headerStyle='none'
                        heading="Dates"
                        des='Date object is used to get the year, month and day. It has methods to get and set day, month, year, hour, minute, and seconds.'

                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='Pulling Date from the Date object'
                        des='Returns the date from the date object.'
                        code={`getDate()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='Pulling Day from the Date object'
                        des='Returns the day from the date object.'
                        code={`getDay()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='Pulling Hours from the Date object'
                        des='Returns the hours from the date object.'
                        code={`getHours()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='Pulling Minutes from the Date object'
                        des='Returns the minutes from the date object.'
                        code={`getMinutes()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='Pulling Seconds from the Date object'
                        des='Returns the seconds from the date object.'
                        code={`getSeconds()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='Pulling Time from the Date object'
                        des='Returns the time from the date object.'
                        code={`getTime()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        headerStyle='none'
                        heading="Mouse Events"
                        des='Any change in the state of an object is referred to as an Event. With the help of JS, you can handle events, i.e., how any specific HTML tag will work when the user does something.'

                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='click'
                        des='Fired when an element is clicked.'
                        code={`element.addEventListener('click', () => {\n\t// Code to be executed when the event is fired\n});`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='oncontextmenu'
                        des='Fired when an element is right-clicked.'
                        code={`element.addEventListener('contextmenu', () => {\n\t// Code to be executed when the event is fired\n});`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='dblclick'
                        des='Fired when an element is double-clicked.'
                        code={`element.addEventListener('dblclick', () => {\n\t// Code to be executed when the event is fired\n});`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='mouseenter'
                        des='Fired when an element is entered by the mouse arrow.'
                        code={`element.addEventListener('mouseenter', () => {\n\t// Code to be executed when the event is fired\n});`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='mouseleave'
                        des='Fired when an element is exited by the mouse arrow.'
                        code={`element.addEventListener('mouseleave', () => {\n\t// Code to be executed when the event is fired\n});`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='mousemove'
                        des='Fired when an element is moved inside the element.'
                        code={`element.addEventListener('mousemove', () => {\n\t// Code to be executed when the event is fired\n});`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        headerStyle='none'
                        heading="Keyboard Events"

                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='keydown'
                        des='Fired when the user is pressing a key on the keyboard.'
                        code={`element.addEventListener('keydown', () => {\n\t// Code to be executed when the event is fired\n});`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='keydown'
                        des='Fired when the user is pressing a key on the keyboard.'
                        code={`element.addEventListener('keydown', () => {\n\t// Code to be executed when the event is fired\n});`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='keydpress'
                        des='Fired when the user is presses a key on the keyboard.'
                        code={`element.addEventListener('keypress', () => {\n\t// Code to be executed when the event is fired\n});`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='keyup'
                        des='Fired when the user releases a key on the keyboard.'
                        code={`element.addEventListener('keyup', () => {\n\t// Code to be executed when the event is fired\n});`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading="Errors"
                        des='Errors are thrown by the compiler or interpreter whenever they find any fault in the code, and it can be of any type like syntax error, run-time error, logical error, etc. JS provides some functions to handle the errors.'

                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='try and catch'
                        des='Try the code block and execute catch when err is thrown.'
                        code={`try {\n\tBlock of code to try\n}\ncatch (err) {\n\tBlock of code to handle errors\n}`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading="Window Methods"
                        des='Methods that are available from the window object.'

                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='alert method'
                        des='Used to alert something on the screen.'
                        code={`alert()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='blur method'
                        des='The blur() method removes focus from the current window.'
                        code={`blur()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='setInterval'
                        des='Keeps executing code at a certain interval.'
                        code={`setInterval(() => {\n\t// Code to be executed\n}, 1000);`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='setTimeout'
                        des='Executes the code after a certain interval of time.'
                        code={`setITimeout(() => {\n\t// Code to be executed\n}, 1000);`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='close'
                        des='The Window. close() method closes the current window.'
                        code={`window.close();`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='confirm'
                        des='The window.confirm() instructs the browser to display a dialog with an optional message, and to wait until the user either confirms or cancels.'
                        code={`window.confirm('Are you sure?');`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='open'
                        des='Opens a new window'
                        code={`window.open('https://zer-0ne.github.io/zer0ne');`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='prompt'
                        des='Prompts the user with a text and takes a value. Second parameter is the default value'
                        code={`var name = prompt("What is your name?", "Sahil");`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='scrollBy'
                        code={`window.scrollBy(100, 0); // Scroll 100px to the right`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='scrollTo'
                        des='Scrolls the document to the specified coordinates.'
                        code={`window.scrollTo(500, 0); // Scroll to horizontal position 500`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='clearInterval'
                        des='Clears the setInterval. var is the value returned by setInterval call.'
                        code={`clearInterval(var)`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='clearTimeout'
                        des='Clears the setInterval. var is the value returned by clearTimeout call.'
                        code={`clearTimeout(var)`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='stop'
                        des='Stops the further resource loading.'
                        code={`stop()`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading="Query/Get Elements"
                        des='The browser creates a DOM (Document Object Model) whenever a web page is loaded, and with the help of HTML DOM, one can access and modify all the elements of the HTML document.'

                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='querySelector'
                        des='Selector to select first matching element.'
                        code={`document.querySelector('css-selectors')`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='querySelectorAll'
                        des='Selector to select all matching element.'
                        code={`document.querySelectorAll('css-selectors',....)`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='getElementsByTagName'
                        des='Select elements by tag name.'
                        code={`document.getElementsByTagName('element-name')`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='getElementsByClassName'
                        des='Select elements by class name.'
                        code={`document.getElementsByClassName('class-name')`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='Get Element by Id'
                        des='Select elements by its id.'
                        code={`document.getElementById('id')`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading="Creating Elements"
                        des='Create new elements in the DOM.'

                        headerStyle='none'
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='createElement'
                        des='Create a new element.'
                        code={`document.createElement('div')`}
                    />
                    <CheetSheetTemplate
                        imgClass='none'
                        language='javascript'
                        heading='createTextNode'
                        des='Create a new text node.'
                        code={`document.createTextNode('some text here')`}
                    />

                </div>
            </ProjectTemplate>
        </>
    )
}